import { useTranslation } from "react-i18next";
import { CONTACT_PHONE_DISPLAY } from "@/mocks/siteData";
import { waLink, telLink, mapEmbedSrc } from "@/lib/links";
import SectionHeading from "@/components/feature/SectionHeading";
import LeaseForm from "@/pages/home/components/LeaseForm";

export default function ContactSection() {
  const { t } = useTranslation();

  return (
    <section id="contact" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          <div>
            <SectionHeading
              align="left"
              eyebrow={t("contact.eyebrow")}
              title={
                <>
                  {t("contact.title1")}
                  <br />
                  {t("contact.title2")}
                </>
              }
              subtitle={t("contact.subtitle")}
            />

            <div className="space-y-5">
              <a
                href={waLink(t("wa.contact"))}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-5 bg-background-50 hover:bg-primary-50 border border-background-200 rounded-lg p-5 cursor-pointer transition"
              >
                <div className="w-12 h-12 shrink-0 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-2xl w-6 h-6 flex items-center justify-center" />
                </div>
                <div>
                  <div className="font-heading font-bold text-foreground-900">{t("contact.whatsappTitle")}</div>
                  <div className="text-foreground-700 mt-1 font-medium">{CONTACT_PHONE_DISPLAY}</div>
                  <div className="text-foreground-500 text-sm mt-0.5">{t("contact.whatsappSub")}</div>
                </div>
              </a>

              <a
                href={telLink}
                className="flex items-start gap-5 bg-background-50 hover:bg-primary-50 border border-background-200 rounded-lg p-5 cursor-pointer transition"
              >
                <div className="w-12 h-12 shrink-0 rounded-lg bg-foreground-900 text-primary-400 flex items-center justify-center">
                  <i className="ri-phone-fill text-2xl w-6 h-6 flex items-center justify-center" />
                </div>
                <div>
                  <div className="font-heading font-bold text-foreground-900">{t("contact.callTitle")}</div>
                  <div className="text-foreground-700 mt-1 font-medium">{CONTACT_PHONE_DISPLAY}</div>
                  <div className="text-foreground-500 text-sm mt-0.5">{t("contact.callHours")}</div>
                </div>
              </a>

              <div className="flex items-start gap-5 bg-background-50 border border-background-200 rounded-lg p-5">
                <div className="w-12 h-12 shrink-0 rounded-lg bg-foreground-900 text-primary-400 flex items-center justify-center">
                  <i className="ri-map-pin-2-fill text-2xl w-6 h-6 flex items-center justify-center" />
                </div>
                <div>
                  <div className="font-heading font-bold text-foreground-900">{t("contact.visitTitle")}</div>
                  <div className="text-foreground-700 mt-1 font-medium">{t("contact.addressLine")}</div>
                  <div className="text-foreground-500 text-sm mt-0.5">{t("contact.addressCity")}</div>
                </div>
              </div>
            </div>

            <div className="mt-8 rounded-lg overflow-hidden border border-background-200 h-64">
              <iframe
                title="Arman Delivery location on the map"
                src={mapEmbedSrc}
                className="w-full h-full"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

          <LeaseForm />
        </div>
      </div>
    </section>
  );
}